import { LOCAL__images_upsert } from '@/state/images/upsert_images/LOCAL__images_upsert';
import { store } from '@/state/store';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { FN_IMAGE_ASSET__add_to_generations } from './_methods/FN_IMAGE_ASSET__add_to_generations';
import { FN_IMAGE_ASSET__add_to_grid2d } from './_methods/FN_IMAGE_ASSET__add_to_grid2d';
import { FN_IMAGE_ASSET__add_to_grid2d_gallery } from './_methods/FN_IMAGE_ASSET__add_to_grid2d_gallery';
import { FN_IMAGE_ASSET__update_generation_layout_image_edit } from './_methods/FN_IMAGE_ASSET__update_generation_layout_image_edit';

export function HANDLER_CLIENT__image_upsert(items: any) {
  assert_array_instanceof(items, DTO__image_asset);

  let images_map_by_hash = new Map<string, DTO__image_asset>();
  for (let image of items) images_map_by_hash.set(image.hash_sha256_content, image);

  FN_IMAGE_ASSET__add_to_generations(images_map_by_hash);
  FN_IMAGE_ASSET__update_generation_layout_image_edit(images_map_by_hash);
  FN_IMAGE_ASSET__add_to_grid2d(items);
  FN_IMAGE_ASSET__add_to_grid2d_gallery(images_map_by_hash);

  store.dispatch(LOCAL__images_upsert(items));
}
